import React from 'react';
import { DownloadIcon, PaperPlaneIcon } from '@radix-ui/react-icons';
import { Spinner } from '../../Spinner';

interface InvoiceActionButtonsProps {
  onDownloadPdf?: () => void;
  onResendInvoice?: () => void;
  isDownloading?: boolean;
  isResending?: boolean;
}

export const InvoiceActionButtons: React.FC<InvoiceActionButtonsProps> = ({
  onDownloadPdf,
  onResendInvoice,
  isDownloading = false,
  isResending = false,
}) => (
  <div className="invoice-details-modal__actions">
    <button
      type="button"
      className="invoice-details-modal__action invoice-details-modal__action--primary"
      onClick={onDownloadPdf}
      disabled={isDownloading || !onDownloadPdf}
    >
      {isDownloading ? <Spinner size="small" /> : <DownloadIcon aria-hidden="true" />}
      {isDownloading ? 'Downloading...' : 'Download PDF'}
    </button>
    <button
      type="button"
      className="invoice-details-modal__action invoice-details-modal__action--secondary"
      onClick={onResendInvoice}
      disabled={isResending || !onResendInvoice}
    >
      <PaperPlaneIcon aria-hidden="true" />
      {isResending ? 'Sending...' : 'Resend Invoice'}
    </button>
  </div>
);
